import { assign } from 'lodash'
import CatchmentPointDto from './CatchmentPointDto'

export default class CatchmentWithLinkDto {
    constructor(obj) {
        assign(this, obj)

        this.catchmentPoints = obj.catchmentPoints?.map(catchmentPoint => new CatchmentPointDto(catchmentPoint)) || [] // Seq[CatchmentPoint]
        this.sdages = obj.sdages || [] // Seq[{Int, Option[DateTime], Option[DateTime], Option[Int], Option[String], Option[Int]}]
    }
}